import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getSingleCondidateById } from "../../../Redux/Actions/newJoinerAction";
import { getNewCondidateQualificationList } from "../../../Redux/Actions/newJoinerAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../CommanCom/Loader";
import moment from 'moment';
import Modal from "react-bootstrap/Modal";

import { updateCandidateRelationship,getCandidateQualificationById } from "../../HR/onboarding/api/Calls"
import { addCandidateRelationship } from './api/Calls';
const ViewJoiningForm = () => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  const login_user_id = localStorage.getItem('userId')

  const cancelRef = useRef(null);
  const dispatch = useDispatch();
  const { viewcondidate, loading } = useSelector((state) => state.NewJoinerReducer);
  const [tab, setTab] = useState(1)
  const [previous, setPrevious] = useState('');
  const [documentView, setDocumentViewer] = useState('')
  const [docFileLoad, setDocFileLoad] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const id = searchParams.get('id')

  const { qualicationList } = useSelector((state) => state.NewJoinerReducer);

  useEffect(() => {
    dispatch(getSingleCondidateById(id));
    // getuserfamilyDetails(id)
    getuserfamilyDetailsByuserId(id)
    dispatch(getNewCondidateQualificationList(id))

  }, [id, tab])

  const [fname, setFname] = useState('')
  const [frelation, setFrelation] = useState('')
  const [age, setAge] = useState('')
  const [dob, setDob] = useState('')
  const [occupation, setOccupation] = useState('')
  const [familyId, setFamilyId] = useState('');


  const [fnameupdate, setFnameupdate] = useState('')
  const [frelationupdate, setFrelationupdate] = useState('')
  const [ageupdate, setAgeupdate] = useState('')
  const [dobupdate, setDobupdate] = useState('')
  const [occupationupdate, setOccupationupdate] = useState('')


  const [familydetails, setFamilydetails] = useState([]);
  const getuserfamilyDetailsByuserId = (id) => {
    const response = fetch(SERVER_URL + `api/common/getfamilydetailsByuserId?userId=${id}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        var res = data.result;
        setFamilydetails(res)
      })
  }


  const getuserfamilyDetails = (id) => {


    const response = fetch(SERVER_URL + `api/common/getfamilydetailsById?id=${id}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        var res = data.result;
        setFname(res.name)
        setFrelation(res.relationship)
        setAge(res.age)
        setOccupation(res.occupation)
        setDob(res.dob)
        setFamilyId(res?.id ? res.id : '')

        setFnameupdate(res.name)
        setFrelationupdate(res.relationship)
        setAgeupdate(res.age)
        setOccupationupdate(res.occupation)
        setDobupdate(res.dob)

      })
  }

  const previousFamilyDetails = (preValue) => {
    setTab(preValue);
    setPrevious(preValue);
  }

  const openDocumentView = (type) => {
    setDocumentViewer(type);
    setDocFileLoad('');
    if (documentView === 1) {
      setDocFileLoad(viewcondidate?.AadharcardFiles)
    } else if (documentView === 2) {
      setDocFileLoad(viewcondidate?.Filepancard)
    } else if (documentView === 3) {
      setDocFileLoad(viewcondidate?.PassportSizePhoto)
    } else if (documentView === 4) {
      setDocFileLoad(viewcondidate?.Vaccination)
    } else if (documentView === 5) {
      setDocFileLoad(viewcondidate?.AddressProof)
    } else if (documentView === 6) {
      setDocFileLoad(viewcondidate?.cancelCheck)
    }
  }
  const [modalstatus, setModalstatus] = useState(false);
  const [fdid, setFdid] = useState('');
  const handleFamilyDetails = (femilydetailId = null) => {
    setFdid(femilydetailId)
    setModalstatus(true)
    getuserfamilyDetails(femilydetailId)
  }
  const [selected, setSelected] = useState(false);
  const handleCancel = () => {
    setModalstatus(false);
    setFnameupdate('');
    setAgeupdate('');
    setFrelationupdate('');
    setOccupationupdate('');
    setDobupdate('');

  };

  const handleChange = (e) => {
    const ageCalculate = e.target.value;

    if (ageCalculate) {
      setDobupdate(ageCalculate)
      var today = new Date();
      var birthDate = new Date(`${moment(ageCalculate).format('YYYY-MM-DD')}`);
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
      }
      setAgeupdate(age_now)

    } else {
      setAgeupdate('');
    }
  };

  const handleSubmit = () => {
    const updatedData = {
      user_id: id,
      age: ageupdate,
      name: fnameupdate,
      relationship: frelationupdate,
      dob: dobupdate,
      occupation: occupationupdate,

    }
    addCandidateRelationship(updatedData, login_user_id).then((res) => {
      if (res.status) {
        setFnameupdate('');
        setAgeupdate('');
        setFrelationupdate('');
        setOccupationupdate('');
        setDobupdate('');

        getuserfamilyDetailsByuserId(id)
        setTimeout(() => {
          setModalstatus(false);
        }, 1000);

        return alert(res.msg)
      } else {
        return alert(res.msg)
      }
    })
  }
  const handleUpdateInfo = () => {
    const updatedData = {
      age: ageupdate,
      name: fnameupdate,
      relationship: frelationupdate,
      dob: dobupdate,
      occupation: occupationupdate,
      updated_by: login_user_id
    }
    updateCandidateRelationship(updatedData, familyId).then((res) => {
      if (res.status) {

        setFname(fnameupdate);
        setAge(ageupdate);
        setFrelation(frelationupdate);
        setOccupation(occupationupdate);
        setDob(dobupdate);


        setFnameupdate('');
        setAgeupdate('');
        setFrelationupdate('');
        setOccupationupdate('');
        setDobupdate('');
        getuserfamilyDetailsByuserId(id)
        setTimeout(() => {
          setModalstatus(false);
        }, 1000);
        return alert(res.msg)
      } else {
        return alert(res.msg)
      }
    })
  }
  const [modalstatusqlft, setModalstatusqlft] = useState(false);
  const [qlyid, setQlyid] = useState('');
  const[qname,setQname] = useState('');
  const handlqualificationModal = (qlfId = null) => {
    alert(qlfId)
    setQlyid(qlfId)
    
    if(qlfId==0){
      setModalstatusqlft(true)
    }else{
      setModalstatusqlft(true)
      getCandidateQualificationById(qlfId).then((res) => {
      })


    }
  }
  const handleqlfCancel = () => {
    setModalstatusqlft(false)
  }
  return (
    <>
      <Modal show={modalstatusqlft} size="md" >
        <div className="modal-body">
          <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
            <i className="icon icon-cross" onClick={handleqlfCancel} />
          </button>
          <div className="dash_white_box_ttl text-center" id="educationModalLabel">{qlyid == 0 ? 'Add' : 'Edit'} Qualification Detail</div>

          <div className="mb-2">
            <label className="col-form-label">Educational Institutions Name <sup className="error_mgs">*</sup></label>
            <input type="text" className="form-control" value={qname} name="name" onChange={handleChange} />
          </div>
          <div className="modalfooter">
            <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleqlfCancel}>Cancel</button>
            <button type="button" onClick={qlyid == 0 ? handleSubmit : handleUpdateInfo} className="btn_5 float-end ">{qlyid == 0 ? 'Add' : 'Update'}</button>
          </div>
        </div>
      </Modal>

      <Modal show={modalstatus} size="md" id="confirm_login">
        <div className="modal-body">
          <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
            <i className="icon icon-cross" ref={cancelRef} onClick={handleCancel} />
          </button>
          <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{fdid === 0 ? 'Add' : 'Edit'} Family Detail</div>

          <div className="mb-2">
            <label className="col-form-label">Name <sup className="error_mgs">*</sup></label>
            <input type="text" className="form-control" id="name" onChange={e => { setFnameupdate(e.target.value) }} name="name" value={fnameupdate} />
          </div>
          <div className="mb-2">
            <label className="col-form-label">Relationship <sup className="error_mgs">*</sup></label>
            <input type="text" className="form-control" id="relationship" onChange={e => { setFrelationupdate(e.target.value) }} name="relationship" value={frelationupdate} />
          </div>
          <div className="mb-2 row">
            <div className="col-md-6"><label className="col-form-label">Date of Birth <sup className="error_mgs">*</sup></label>
              <input type="date" className="form-control" id="dob" onChange={handleChange} name="dob" value={moment(dobupdate).format('yyyy-MM-DD')} />

            </div>
            <div className="col-md-6">
              <label className="col-form-label">Age </label>
              <input type="text" className="form-control" id="age" onChange={e => { setAgeupdate(e.target.value) }} name="age" value={ageupdate} />
            </div>
          </div>
          <div className="mb-4">
            <label className="col-form-label">Occupation <sup className="error_mgs">*</sup></label>
            <input type="text" className="form-control" id="occupation" onChange={e => { setOccupationupdate(e.target.value) }} name="occupation" value={occupationupdate} />
          </div>
          <div className="modalfooter">
            <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
            <button type="button" onClick={fdid === 0 ? handleSubmit : handleUpdateInfo} className="btn_5 float-end ">{fdid === 0 ? 'Add' : 'Update'}</button>
          </div>
        </div>
      </Modal>

      <div className="page-header">
        <h1></h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <span>/</span> <Link to="/onboarding">Candidate</Link>
          </li>
          <li className="current">
            <span>/</span> View Join form
          </li>
        </ul>
      </div>
      <div className="row_bg">
        {loading ? (
          <Loader />
        ) : (
          <div className="profile_wrapper mb30">
            <div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">
              <a className={`nav-link ${tab === 1 ? 'active' : ''}`} onClick={() => setTab(1)} id="employmentprofile-tab" data-bs-toggle="tab" href="#employmentprofile" data-bs-target="#employmentprofile">
                Personal Profile
              </a>
              <span className="middleline" />
              <a className={`nav-link ${tab === 2 ? 'active' : ''}`} onClick={() => setTab(2)} id="familydetail-tab" data-bs-toggle="tab" href="#familydetail" data-bs-target="#familydetail">
                Family Detail
              </a>
              <span className="middleline" />
              <a className={`nav-link ${tab === 3 ? 'active' : ''}`} onClick={() => setTab(3)} id="qualification-tab" data-bs-toggle="tab" href="#qualificationdetail" data-bs-target="#qualificationdetail">
                Qualification Detail
              </a>
              <span className="middleline" />
              <a className={`nav-link ${tab === 4 ? 'active' : ''}`} onClick={() => setTab(4)} id="previousemployment-tab" data-bs-toggle="tab" href="#previousemploymentdetail" data-bs-target="#previousemploymentdetail">
                Previous Employment Detail
              </a>
            </div>
            <div className="tab-content" id="profile-tabContent">
              <div className={`tab-pane fade ${tab === 1 ? 'show active' : ''}`} id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
                <div className="tab_content">
                  <div className="dash_white_box_ttl">PERSONAL PROFILE</div>
                  <div className="row mb25">
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Salutation <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <select className="form-select" name="salutation" id="salutation">
                            <option value="">Select</option>
                            <option value='1'>Mr.</option>
                            <option value='2'>Mis.</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">First Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span><sup className="error_mgs">*</sup></span></span></div>
                        <div className="form-input">
                          <input type="text" value={viewcondidate?.first_name} id="first_name" name="first_name" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Middle Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span /></span></div>
                        <div className="form-input">
                          <input type="text" value={viewcondidate?.middlename} name="middlename" id="middlename" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Last Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span /></span></div>
                        <div className="form-input">
                          <input type="text" value={viewcondidate?.lastname} name="lastname" id="lastname" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Father/Husband Name <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="fatherhusbandname" value={viewcondidate?.fatherhusbandname} id="fatherhusbandname" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Gender <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <select className="form-select" value={viewcondidate?.gender} name="gender" id="gender">
                            <option value="">Select Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">E-Mail <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" className="form-control" name="personal_email" value={viewcondidate?.personal_email} id="personal_email" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Alternate E-Mail</div>
                        <div className="form-input">
                          <input type="text" className="form-control" name="alternateemail" value={viewcondidate?.alternateemail} id="alternateemail" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Phone Number <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" className="form-control" name="phonenumber" value={viewcondidate?.phonenumber} id="phonenumber" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Date Of Birth <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="date" className="form-control" name="dateofbirth" value={moment(viewcondidate?.dateofbirth).format('yyyy-MM-DD')} id="dateofbirth" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Age</div>
                        <div className="form-input">
                          <input type="text" className="form-control" name="age" value={viewcondidate?.age ? viewcondidate?.age : ''} id="age" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Hobbies</div>
                        <div className="form-input">
                          <input type="text" className="form-control" name="hobbies" value={viewcondidate?.hobbies ? viewcondidate?.hobbies : ''} id="hobbies" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Marital Status <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <select className="form-select" name="marital_status" id="marital_status">
                            <option value="">Select Marital Status</option>
                            <option value="1">Married</option>
                            <option value="2">Unmarried</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Wedding Anniversary Date</div>
                        <div className="form-input">
                          <input type="date" value={moment(viewcondidate?.weddinganniversary ? viewcondidate?.weddinganniversary : '').format('yyyy-MM-DD')} name="weddinganniversary" id="weddinganniversary" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Date of joining</div>
                        <div className="form-input">
                          <input type="date" value={moment(viewcondidate?.dateofjoining ? viewcondidate?.dateofjoining : '').format('yyyy-MM-DD')} name="dateofjoining" id="dateofjoining" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Blood Group <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="bloodgroup" value={viewcondidate?.bloodgroup ? viewcondidate?.bloodgroup : ''} id="bloodgroup" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Weight <sup>( Kg )</sup> </div>
                        <div className="form-input">
                          <input type="text" name="Weight" value={viewcondidate?.Weight ? viewcondidate?.Weight : ''} id="Weight" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Height <sup>( inches )</sup></div>
                        <div className="form-input">
                          <input type="text" name="height" value={viewcondidate?.height ? viewcondidate?.height : ''} id="height" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Emergency Contact Person <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="emergencycontactperson" value={viewcondidate?.emergencycontactperson ? viewcondidate?.emergencycontactperson : ''} id="emergencycontactperson" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Emergency Contact person Relationship <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="personrelation" value={viewcondidate?.personrelation ? viewcondidate?.personrelation : ''} id="personrelation" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Emergency Phone Number <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="emergencyphonenumber" value={viewcondidate?.emergencyphonenumber ? viewcondidate?.emergencyphonenumber : ''} id="emergencyphonenumber" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Nationality <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="nationality" value={viewcondidate?.nationality ? viewcondidate?.nationality : ''} id="nationality" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Aadhaar Card Number <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="aadhaarcardnumber" value={viewcondidate?.aadhaarcardnumber ? viewcondidate?.aadhaarcardnumber : ''} id="aadhaarcardnumber" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Upload Aadhar Card <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {viewcondidate?.AadharcardFiles != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.AadharcardFiles ? viewcondidate?.AadharcardFiles : ''} /> : ''}
                          {viewcondidate?.AadharcardFiles != '' ? <button className="btn_7 " onClick={() => openDocumentView(1)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}

                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Pan Card Number <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="pancardnumber" value={viewcondidate?.pancardnumber ? viewcondidate?.pancardnumber : ''} id="pancardnumber" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Upload Pan Card <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {viewcondidate?.Filepancard != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.Filepancard} /> : ''}
                          {viewcondidate?.Filepancard != '' ? <button className="btn_7 " onClick={() => openDocumentView(2)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}

                          {/* <input type="file" name="filepancard" className="form-control" id="filepancard" /> */}
                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">UAN Number</div>
                        <div className="form-input">
                          <input type="text" name="uanno" value={viewcondidate?.uanno} id="uanno" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Passport Number</div>
                        <div className="form-input">
                          <input type="text" name="Passportno" value={viewcondidate?.Passportno} id="Passportno" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Passport size Photograph <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {viewcondidate?.PassportSizePhoto != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.PassportSizePhoto} /> : ''}
                          {viewcondidate?.PassportSizePhoto != '' ? <button className="btn_7 " onClick={() => openDocumentView(3)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}


                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Fully Vaccination Certificates</div>
                        <div className="form-input input-group">
                          {viewcondidate?.Vaccination != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.Vaccination} /> : ''}
                          {viewcondidate?.Vaccination != '' ? <button className="btn_7 " onClick={() => openDocumentView(4)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}


                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Upload Address Proof <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {viewcondidate?.AddressProof != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.AddressProof} /> : ''}
                          {viewcondidate?.AddressProof != '' ? <button className="btn_7 " onClick={() => openDocumentView(5)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}



                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab_sub_ttl mb00">Address</div>
                  <div className="row mb25">
                    <div className="col-md-6">
                      <div className="form-blk mb10">
                        <div className="form-label">Current Address <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <textarea className="form-control form-control1" name="currentAddress" value={viewcondidate?.currentAddress} id="currentAddress" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb10">
                        <div className="form-label">Permanent Address <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <textarea className="form-control form-control1" name="PermanentAddress" value={viewcondidate?.PermanentAddress} id="PermanentAddress" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab_sub_ttl">Bank Details</div>
                  <div className="row mb25">
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Salary Bank <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <select className="form-select" name="bankSalaryType" value={viewcondidate?.bankSalaryType} id="bankSalaryType">
                            <option value="">Select Salary Type</option>
                            <option value={1}>Salary Account</option>
                            <option value={2}>Saving Account</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Salary Account Number <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" placeholder="Enter Salary Account Number" name="accountno" value={viewcondidate?.accountno} id="accountno" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk mb10">
                        <div className="form-label">Salary IFSC Code <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" placeholder="Enter Salary IFSC Code" name="ifsc_code" id="ifsc_code" value={viewcondidate?.ifsc_code} className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk">
                        <div className="form-label">Upload Cancel Check <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {viewcondidate?.cancelCheck != '' ? <input type="text" className="form-control form-control1" value={viewcondidate?.cancelCheck} /> : ''}
                          {viewcondidate?.cancelCheck != '' ? <button className="btn_7 " onClick={() => openDocumentView(5)} data-bs-toggle="modal" data-bs-target="#documentviews"><i className="icon icon-eye"></i></button> : ''}



                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_footer text-end">
                  <button className="btn_5" onClick={() => setTab(2)}>Next</button>
                </div>
              </div>
              <div className={`tab-pane fade ${tab === 2 ? 'show active' : ''}`} id="familydetail" role="tabpanel" aria-labelledby="familydetail-tab">
                <div className="tab_content">
                  <button className="btn_5 float-end mb15" data-bs-toggle="modal" onClick={() => { handleFamilyDetails(0) }}> Add Family Detail</button>
                  <div className="dash_white_box_ttl mb25">FAMILY DETAIL</div>
                  <table className="monthly_table mt20">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Relationship</th>
                        <th>Age </th>
                        <th>Date of Birth</th>
                        <th>Occupation</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        familydetails.map((item, ind) => {
                          return <tr key={ind}>
                            <td>{item.name}</td>
                            <td>{item.relationship}</td>
                            <td>{item.age}</td>
                            <td>{item?.dob ? moment(item?.dob).format('DD MMM, yyyy') : ''}</td>
                            <td>{item.occupation}</td>
                            <td className="text-right">
                              <button onClick={() => { handleFamilyDetails(item.id) }} className="btn_7"><i className="icon icon-pencil" />Update</button>
                              <button className="btn_8"><i className="icon icon-cross" />Delete</button>
                            </td>
                          </tr>

                        })
                      }
                      {/* <tr>
                        <td>{fname ? fname : 'N/A'}</td>
                        <td>{frelation ? frelation : 'N/A'}</td>
                        <td>{age ? age : ''}</td>
                        <td>{dob ? moment(dob).format('DD MMM, yyyy') : ''}</td>
                        <td>{occupation}</td>
                        <td className="text-right">
                          <button className="btn_7"><i className="icon icon-pencil" /></button>
                          <button className="btn_8"><i className="icon icon-cross" /></button>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
                <div className="tab_footer text-end">
                  <button className="btn_5 float-start" onClick={() => previousFamilyDetails(1)}>Previous</button>
                  <button className="btn_5" onClick={() => setTab(3)}>Next</button>
                </div>
              </div>
              <div className={`tab-pane fade ${tab === 3 ? 'show active' : ''}`} id="qualificationdetail" role="tabpanel" aria-labelledby="qualification-tab">
                <div className="tab_content">
                  <button className="btn_5 float-end mb15" onClick={e => { handlqualificationModal('0') }}>Add Qualification Detail</button>
                  <div className="dash_white_box_ttl mb25">QUALIFICATION DETAIL</div>
                  <table className="monthly_table mt20 mb25">
                    <thead>
                      <tr rowSpan={2}>
                        <th>Educational Institutions Name</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Degree / Diploma Major Subjects </th>
                        <th>Major Subjects</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {qualicationList?.length > 0 ?
                        qualicationList?.map((item, ind) => {
                          return <tr key={ind}>
                            <td>{item.name}</td>
                            <td>{item.from_year}</td>
                            <td>{item.to_year}</td>
                            <td>{item.degree_name}</td>
                            <td>{item.subject}</td>
                            <td className="text-right">
                              <button className="btn_9"><i className="icon icon-download" />download</button>
                              <button className="btn_7" onClick={e => { handlqualificationModal(item.id) }}><i className="icon icon-pencil" />Edit</button>
                              <button className="btn_8"><i className="icon icon-cross" />Delete</button>
                            </td>
                          </tr>

                        })
                        :
                        <tr>
                          <td colSpan={6} className="text-center">
                            <div className="notfound">No Record found</div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div className="tab_footer text-end">
                  <button className="btn_5 float-start" onClick={() => previousFamilyDetails(2)}>Previous</button>
                  <button className="btn_5" onClick={() => setTab(4)}>Next</button>
                </div>
              </div>
              <div className={`tab-pane fade ${tab === 4 ? 'show active' : ''}`} id="previousemploymentdetail" role="tabpanel" aria-labelledby="previousemployment-tab">
                <div className="tab_content">
                  <button className="btn_5 float-end" data-bs-toggle="modal" data-bs-target="#previouscompanydetail">Add Previous Employment</button>
                  <div className="dash_white_box_ttl mb25">PREVIOUS EMPLOYMENT DETAIL</div>
                  <table className="monthly_table mt20 mb25">
                    <thead>
                      <tr rowSpan={2}>
                        <th>Company Name</th>
                        <th>Title of Position</th>
                        <th>Name &amp; Phone No. of Supervisor</th>
                        <th>From &amp; Till Date</th>
                        <th>Total CTC including Benefits</th>
                        <th>Address of Employer</th>
                        <th>Reason for Leaving</th>
                        <th style={{ width: '150px' }} className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>QBS Learning</td>
                        <td>Designer</td>
                        <td>Vibha (9876554332221)</td>
                        <td>22 sept 2022 to 22 sept 2023</td>
                        <td>898989</td>
                        <td>D 8, QBS Learning sector 3 noida</td>
                        <td>For carrier growth</td>
                        <td className="text-right">
                          <button className="btn_9"><i className="icon icon-download" /></button>
                          <button className="btn_7"><i className="icon icon-pencil" /></button>
                          <button className="btn_8"><i className="icon icon-cross" /></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="joining_blk">
                    <div className="tab_sub_ttl mb00">Previous Company Salary Slip</div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-blk">
                          <div className="form-label">Slip 1</div>
                          <div className="form-input input-group">
                            {/* <input type="file" name="file" required className="form-control" id="inputGroupFile01" />
                                  <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-blk">
                          <div className="form-label">Slip 2</div>
                          <div className="form-input input-group">
                            {/* <input type="file" name="file" required className="form-control" id="inputGroupFile01" />
                                  <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-blk">
                          <div className="form-label">Slip 3</div>
                          <div className="form-input input-group">
                            {/* <input type="file" name="file" required className="form-control" id="inputGroupFile01" />
                                  <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_footer text-end">
                  <button className="btn_5 float-start" onClick={() => previousFamilyDetails(3)}>Previous</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="modal fade" id="documentviews" tabIndex={-1} aria-labelledby="documentViewsLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                <i className="icon icon-cross" />
              </button>
              <div className="dash_white_box_ttl text-center" id="documentViewsLabel">Document View</div>

              <iframe width="100%" height="90%"
                title="Grid Generator"
                allow="autoplay"
                src={`${SERVER_URL}proof/${docFileLoad}`}

              />
            </div>
          </div>
        </div>
      </div>


    </>
  )
}
export default ViewJoiningForm;